// extracted by mini-css-extract-plugin
export default {"image_border":"formik_image_border__XgrD-","border_none":"formik_border_none__A4Zcn"};